import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "aiyaiyai_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: API });
http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Public
export const getMeta = () => http.get("/meta").then((r) => r.data);
export const getCases = (params = {}) => http.get("/cases", { params }).then((r) => r.data);
export const getCase = (slug) => http.get(`/cases/${slug}`).then((r) => r.data);
export const getHeroCase = () => http.get("/cases/hero").then((r) => r.data);
export const getFeaturedGrid = (limit = 4) => http.get("/cases/featured-grid", { params: { limit } }).then((r) => r.data);
export const getRelated = (slug) => http.get(`/cases/${slug}/related`).then((r) => r.data);
export const getTrends = () => http.get("/trends").then((r) => r.data);

// Auth
export const login = (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => http.get("/auth/me").then((r) => r.data);

// Admin
export const adminListCases = (status) => http.get("/admin/cases", { params: status ? { status } : {} }).then((r) => r.data);
export const adminGetCase = (slug) => http.get(`/admin/cases/${slug}`).then((r) => r.data);
export const adminCreateCase = (data) => http.post("/admin/cases", data).then((r) => r.data);
export const adminUpdateCase = (slug, data) => http.put(`/admin/cases/${slug}`, data).then((r) => r.data);
export const adminSetStatus = (slug, status) => http.patch(`/admin/cases/${slug}/status`, { status }).then((r) => r.data);
export const adminDeleteCase = (slug) => http.delete(`/admin/cases/${slug}`).then((r) => r.data);
export const adminSetHero = (slug) => http.post(`/admin/cases/${slug}/hero`).then((r) => r.data);

// Discovery
export const getDiscoveryStats = () => http.get("/admin/discovery/stats").then((r) => r.data);
export const getDiscoverySources = () => http.get("/admin/discovery/sources").then((r) => r.data);
export const getDiscoveryRuns = () => http.get("/admin/discovery/runs").then((r) => r.data);
export const getDiscoveryCandidates = (status) => http.get("/admin/discovery/candidates", { params: status ? { status } : {} }).then((r) => r.data);
export const runDiscovery = (body) => http.post("/admin/discovery/run", body).then((r) => r.data);
export const approveCandidate = (id, publish = true, image) => http.post(`/admin/discovery/candidates/${id}/approve`, {}, { params: { publish, ...(image ? { image } : {}) } }).then((r) => r.data);
export const rejectCandidate = (id, reason) => http.post(`/admin/discovery/candidates/${id}/reject`, {}, { params: reason ? { reason } : {} }).then((r) => r.data);
export const updateCandidate = (id, data) => http.put(`/admin/discovery/candidates/${id}`, data).then((r) => r.data);

// Explore Opportunity
export const startExplore = (slug, country) => http.post("/explore", { slug, country }).then((r) => r.data);
export const getExploration = (id) => http.get(`/explore/${id}`).then((r) => r.data);
export const refreshExploration = (id) => http.post(`/explore/${id}/refresh`).then((r) => r.data);
export const getExplorations = () => http.get("/admin/explorations").then((r) => r.data);

// Sources & discovery mix
export const getDiscoveryMix = () => http.get("/admin/discovery/mix").then((r) => r.data);
export const getDiscoveredSources = () => http.get("/admin/discovery/discovered-sources").then((r) => r.data);
export const setSourceStatus = (name, status) => http.post(`/admin/discovery/sources/${encodeURIComponent(name)}/status`, { status }).then((r) => r.data);
export const setSourceTier = (name, tier, status = "ACTIVE") => http.post(`/admin/discovery/sources/${encodeURIComponent(name)}/tier`, { tier, status }).then((r) => r.data);
export const getHeroRotation = () => http.get("/admin/hero-rotation").then((r) => r.data);
export const setHeroRotation = (enabled) => http.post("/admin/hero-rotation", { enabled }).then((r) => r.data);
export const rotateHeroNow = () => http.post("/admin/hero-rotation/rotate").then((r) => r.data);
export const retireOldCases = () => http.post("/admin/cases/retire-old").then((r) => r.data);

// Patterns (Phase 4)
export const getPatterns = () => http.get("/patterns").then((r) => r.data);
export const getPattern = (slug) => http.get(`/patterns/${slug}`).then((r) => r.data);
export const getCasePatterns = (slug) => http.get(`/cases/${slug}/patterns`).then((r) => r.data);
export const startPatternExplore = (slug, country) => http.post(`/patterns/${slug}/explore`, { country }).then((r) => r.data);
export const getPatternExploration = (id) => http.get(`/pattern-explore/${id}`).then((r) => r.data);
export const adminGetPatterns = (status) => http.get("/admin/patterns", { params: status ? { status } : {} }).then((r) => r.data);
export const adminGetPattern = (id) => http.get(`/admin/patterns/${id}`).then((r) => r.data);
export const adminDetectPatterns = () => http.post("/admin/patterns/detect").then((r) => r.data);
export const adminDetectStatus = () => http.get("/admin/patterns/detect/status").then((r) => r.data);
export const adminEditPattern = (id, data) => http.put(`/admin/patterns/${id}`, data).then((r) => r.data);
export const adminPatternRemoveCase = (id, slug) => http.post(`/admin/patterns/${id}/cases/remove`, { slug }).then((r) => r.data);
export const adminPatternAddCase = (id, slug) => http.post(`/admin/patterns/${id}/cases/add`, { slug }).then((r) => r.data);
export const adminApprovePattern = (id) => http.post(`/admin/patterns/${id}/approve`).then((r) => r.data);
export const adminRejectPattern = (id) => http.post(`/admin/patterns/${id}/reject`).then((r) => r.data);
export const adminMergePattern = (id, into_id) => http.post(`/admin/patterns/${id}/merge`, { into_id }).then((r) => r.data);
export const findMoreLikeThis = (slug) => http.post(`/admin/cases/${slug}/find-more`).then((r) => r.data);
export const findSupportingEvidence = (cid) => http.post(`/admin/discovery/candidates/${cid}/find-evidence`).then((r) => r.data);

export const MARKETS = [
  { name: "South Africa", code: "ZA", flag: "🇿🇦" },
  { name: "United States", code: "US", flag: "🇺🇸" },
  { name: "United Kingdom", code: "GB", flag: "🇬🇧" },
  { name: "Germany", code: "DE", flag: "🇩🇪" },
  { name: "Australia", code: "AU", flag: "🇦🇺" },
  { name: "Nigeria", code: "NG", flag: "🇳🇬" },
  { name: "Global / Multi", code: "GL", flag: "🌐" },
];

export const ACCENTS = {
  blue: { bg: "bg-cobalt", text: "text-white", sub: "text-white/80", badge: "bg-white text-cobalt", ring: "ring-cobalt" },
  orange: { bg: "bg-brorange", text: "text-white", sub: "text-white/85", badge: "bg-ink text-white", ring: "ring-brorange" },
  lime: { bg: "bg-brlime", text: "text-ink", sub: "text-ink/70", badge: "bg-ink text-brlime", ring: "ring-brlime" },
  pink: { bg: "bg-brpink", text: "text-white", sub: "text-white/85", badge: "bg-bryellow text-ink", ring: "ring-brpink" },
  yellow: { bg: "bg-bryellow", text: "text-ink", sub: "text-ink/70", badge: "bg-ink text-bryellow", ring: "ring-bryellow" },
};

export const accentDot = {
  blue: "bg-cobalt", orange: "bg-brorange", lime: "bg-brlime", pink: "bg-brpink", yellow: "bg-bryellow",
};
